import { render, staticRenderFns } from "./CharCounter.vue?vue&type=template&id=5162ac2d&scoped=true&"
import script from "./CharCounter.vue?vue&type=script&lang=js&"
export * from "./CharCounter.vue?vue&type=script&lang=js&"
import style0 from "./CharCounter.vue?vue&type=style&index=0&id=5162ac2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162ac2d",
  null
  
)

export default component.exports